// import styled from 'styled-components'

import { Filter } from './Filter'
import { useNewsList } from './useNewsList'
// import { NewsItem } from '@/components/elements/News/NewsItem'
// import { Pagination } from '@/components/elements/Pagination'
import { Spacer } from '@/components/elements/Spacer'
import { getYearOptions } from '@/components/enpages/News/dateOptions'

import { useFadeTransition } from '@/hooks/useFadeTransition'
import type { NewsRelease, NewsReleaseTag } from '@/types/newsRelease'

type Props = {
  newsRelease: NewsRelease[]
  tagList: readonly NewsReleaseTag[]
  initialTag: string | undefined
}

export const NewsList = ({ newsRelease, tagList, initialTag }: Props) => {
  const COUNT_PER_PAGE = 10
  const {
    selectedTags,
    // displayNewsList,
    // currentPage,
    // totalCount,
    changeSelectedYear,
    changeSelectedMonth,
    changeSelectedTag,
    // transitionPage,
    handleAllTags,
  } = useNewsList(newsRelease, COUNT_PER_PAGE, initialTag)
  const {transitionFn } = useFadeTransition(300)

  return (
    <div>
      <Filter
        selectedTags={selectedTags}
        tagList={tagList}
        yearOptions={getYearOptions(newsRelease)}
        changeSelectedYear={(e) => transitionFn(() => changeSelectedYear(e))}
        changeSelectedMonth={(e) => transitionFn(() => changeSelectedMonth(e))}
        changeSelectedTag={(text) =>
          transitionFn(() => changeSelectedTag(text))
        }
        handleAllTags={handleAllTags}
      />
      <Spacer h={{ sp: 40, pc: 80 }} />
      {/* {render(
        <List>
          {displayNewsList.length > 0 ? (
            displayNewsList.map((item) => (
              <NewsItem
                key={item._id}
                publishDate={item.publishDate}
                tag={item.tag}
                title={item.title}
                link={`/news/release/${item._id}`}
              />
            ))
          ) : (
            <Message>一致する記事がみつかりませんでした</Message>
          )}
        </List>
      )} */}
      {/* {totalCount > 0 && (
        <>
          <Spacer h={{ sp: 47, pc: 77 }} />
          <Pagination
            totalCount={totalCount}
            countPerPage={COUNT_PER_PAGE}
            currentPage={currentPage}
            transitionPage={(page) => transitionFn(() => transitionPage(page))}
          />
        </>
      )} */}
    </div>
  )
}

// const List = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 24px;
// `

// const Message = styled.h3`
//   font-size: 16px;
//   letter-spacing: 0.64px;
//   line-height: 26px;

//   @media screen and (max-width: 1047px) {
//     font-size: 15px;
//     line-height: 24px;
//     letter-spacing: 0;
//   }
// `
